import React, { useState, useEffect } from 'react';
import { Alert } from '@mm/components';
import FormFieldWrapper from '../../../../../common/components/FormFieldWrapper/FormFieldWrapper';
import TextInput from '../../../../../common/components/TextInput';
import { isValidForS3 as validateSlug } from '../../../common/helpers/isValidForS3/isValidForS3';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';

type Props = {
  slug?: string;
  updateSlug: (slug: string) => void;
  className?: string;
};

export const EditSlug = ({ slug, updateSlug, className }: Props) => {
  const [slugValue, setSlugValue] = useState(slug || '');
  const [errorMessage, setErrorMessage] = useState('');
  const isValid = validateSlug(slugValue);

  useEffect(() => {
    if (slugValue && !isValid) {
      setErrorMessage(
        'Link should only contain latin letters, numbers, - (dash), _ (underscore) symbol',
      );
    } else {
      setErrorMessage('');
    }
  }, [slugValue]);

  const onSlugBlur = () => {
    if (isValid) {
      updateSlug(slugValue);
    }
  };

  return (
    <FormFieldWrapper className={className}>
      <div className="edit-promoter-panel__label">Customize Link</div>
      {errorMessage && (
        <Alert
          type="error"
          className="edit-promoter-panel__slug-alert"
          showCloseIcon={false}
        >
          {errorMessage}
        </Alert>
      )}
      <div className="edit-promoter-panel__slug-input">
        <TextInput
          value={slugValue}
          onChange={e => setSlugValue(e.target.value)}
          onBlur={onSlugBlur}
          maxLength={50}
        />
        <div className="edit-promoter-panel__add-slug-button">
          <PrimaryButton
            disabled={!slugValue}
            onClick={onSlugBlur}
            className="edit-promoter-panel__add-slug-btn"
          >
            Add
          </PrimaryButton>
        </div>
      </div>
    </FormFieldWrapper>
  );
};
